// ----------------------------------------------------------------------
// <copyright file="Izenda.OperatorValueTwoInput.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * OperatorValueTwoInput component
 */
!(function() {
  'use strict';
  var m = require('mobx-react');
  var React = require('react');
  var Input = require('share/components/controls/Izenda.Input');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var OperatorValueTwoInput = React.createClass({
    propTypes: {
      filterInfo: React.PropTypes.object.isRequired,
      onChange: React.PropTypes.func
    },

    render: function() {
      var props = this.props;
      var filterInfo = props.filterInfo || {};
      return (
        <GridLayout className='izenda-FilterRangeInput'>
          <Input
            onChange={onChangeLessThanString.bind(this)}
            value={filterInfo.value && filterInfo.value[0]}
            className='form-control'
            disabled={props.disabled}
          />
          <div className='izenda-Filter-BetweenIcon'>
            <span className='icon-big-arr' />
          </div>
          <Input
            onChange={onChangeGreaterThanString.bind(this)}
            value={filterInfo.value && filterInfo.value[1]}
            className='form-control'
            disabled={props.disabled}
          />
        </GridLayout>
      );

      function onChangeLessThanString(e) {
        var greaterThanString = this.props.filterInfo.value[1] || '';
        this.props.onChange && this.props.onChange([e.target.value, greaterThanString]);
      }

      function onChangeGreaterThanString(e) {
        var lessThanString = this.props.filterInfo.value[0] || '';
        this.props.onChange && this.props.onChange([lessThanString, e.target.value]);
      }
    }
  });

  module.exports = OperatorValueTwoInput;
})();



// WEBPACK FOOTER //
// ./ui/modules/OperatorValue/Izenda.OperatorValueTwoInput.jsx